import { TransitionStatus } from "react-transition-group";
import styled from "styled-components";
import { fontSizeMap as textFontSizeMap, fontWeightMap as textFontWeightMap } from "../../../../../Text/Text.style.js";
import { SidebarItemText } from "../SidebarItemBody/style.js";
import { SidebarItemSubMenuProps } from "./types.js";

export const SubMenusDiv = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${(props) => props.theme.spacing[16]};
    max-width: 100%;
    padding: ${(props) => props.theme.spacing[4]} 0;
    flex: 1 1 auto;
    overflow-x: hidden;
    min-width: 0;
`;

export const VerticalLine = styled.div`
    border-left: 1px solid ${(props) => props.theme.grayscale[70]};
    flex: 0 0 1px;
`;

type SubMenuContainerProps = {
    transitionDuration: number;
    transitionState: TransitionStatus;
    isOpen: boolean;
};

export const SubMenuContainer = styled.div<SubMenuContainerProps>`
    display: flex;
    flex-direction: row;
    padding-top: ${(props) => props.theme.spacing[4]};
    gap: ${(props) => props.theme.spacing[16]};
    padding-left: ${(props) => props.theme.spacing[24]};
    max-width: 100%;
    overflow-x: hidden;
    display: ${({ isOpen }) => (!isOpen ? "none" : "flex")};
    opacity: ${({ transitionState }) => (transitionState === "entered" ? 1 : 0)};
    transition: opacity ${({ transitionDuration }) => transitionDuration * 0.75}ms
        ${({ transitionDuration, transitionState }) => (transitionState === "entered" ? transitionDuration * 0.25 : 0)}ms linear;
`;

type StyledSidebarSubMenuItemProps = Pick<SidebarItemSubMenuProps, "disabled"> & {
    selected: boolean;
};

export const StyledSidebarSubMenuItem = styled.div<StyledSidebarSubMenuItemProps>`
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    color: ${(props) => (!!props.selected && !props.disabled ? props.theme.colors.primary[100] : props.theme.grayscale[80])};
    font-size: ${(props) => props.theme.rem(textFontSizeMap["x-small"])};
    font-weight: ${textFontWeightMap.bold};
    padding: 0;
    max-width: 100%;
    min-width: 0;

    > ${SidebarItemText} {
        flex: 1 1 auto;
    }

    &:hover {
        color: ${(props) => (!props.disabled ? props.theme.colors.primary[100] : "auto")};
    }
`;
